import * as apiRoutes from '../../apiRoutes';
import { userProfileAction } from "../../actionTypes";
import { AuthUrl, ErrorData } from "../../constants";
import * as api from '../../tools/apiMiddleware';

const initialUserProfileState = {
    email: '',
    mobile: '',
    codeSent: false,
    validationMessage: '',
    canEdit: false,
    reload: false,
    showWarning: false,
    countries: [{prefix: "+44", name: "United Kingdoms"}]
};

export const actionCreators = {
    getUserProfile: (reload) => async (dispatch) => {

        if (reload === true) {
            await dispatch({ type: userProfileAction.reload });
        }
        else {
            let url = AuthUrl + apiRoutes.GetUserProfile;
            await api.getRequest(dispatch, url, userProfileAction.beforeSendingRequest, userProfileAction.getUserProfile, userProfileAction.failed);
        }
    },
    setMobileNumber: (number) => async (dispatch) => {

        let url = AuthUrl + apiRoutes.SetUserMobileNumber;
        await api.postRequest(dispatch, url, { "number": number }, userProfileAction.beforeSendingRequest, userProfileAction.updateMobilePhone, userProfileAction.failed, true);
    },
    resendVerificationCode: () => async (dispatch) => {

        let url = AuthUrl + apiRoutes.ResendUserMobileVerificationCode;
        await api.postRequest(dispatch, url, null, userProfileAction.beforeSendingRequest, userProfileAction.resendMobileVerificationCode, userProfileAction.failed, true);
    },
    verifyMobile: (code) => async (dispatch) => {

        let url = AuthUrl + apiRoutes.VerifyUserMobileNumber;
        await api.postRequest(dispatch, url, { "code": code }, userProfileAction.beforeSendingRequest, userProfileAction.validateMobilePhone, userProfileAction.failed, true);
    }
};

export const reducer = (state, action) => {
    state = state || initialUserProfileState;
    switch (action.type) {
        case userProfileAction.reload:
            return {
                ...initialUserProfileState,
                reload: true
            };
        case userProfileAction.beforeSendingRequest: 
            return { ...state };
        case userProfileAction.getUserProfile:
            return {
                ...state,
                email: action.data.email,
                mobile: action.data.phoneNumber,
                mobileVerified: action.data.phoneVerified,
                canEdit: action.data.editable,
                countries: action.data.countries,
                reload: false
            };
         
        case userProfileAction.updateMobilePhone:
            let validationMessage = action.data.status === 1 ? '' : 'Failed to send verification code.';
            validationMessage = action.data.status === 2 ? 'Mobile number already verified.' : validationMessage;
            validationMessage = action.data.status === 3 ? 'Please provide a valid phone number.' : validationMessage;
            validationMessage = action.data.status === 4 ? 'Too many failed attempts. Please try again in 30 minutes.' : validationMessage;
            return {
                ...state,
                codeSent: action.data.status === 1,
                validationMessage: validationMessage,
                showWarning: validationMessage.length > 0
            };
        case userProfileAction.resendMobileVerificationCode:
            let resendMessage = action.data.status === 1 ? 'A new verification code has been sent.' : 'Failed to resend verification code.';
            resendMessage = action.data.status === 2 ? 'Too many failed attempts. Please try again in 30 minutes.' : resendMessage;
            return {
                ...state,
                codeSent: true,
                validationMessage: resendMessage,
                showWarning: action.data.status !== 1
            };
            
        case userProfileAction.validateMobilePhone:
            if (action.data.status === 0) {
                return {
                    ...state,
                    validationMessage: 'Code not valid. Please check this was entered correctly. If more than 3 minutes has passed since requesting a code please click resend to receive a new code.',
                    showWarning: true
                };
            }

            state = initialUserProfileState;
            return {
                ...state,
                reload: true
            };   
        case userProfileAction.failed:
            return {
                ...state
            };
    }
    return state;
};


// WEBPACK FOOTER //
// ./src/store/User/UserStore.js